export default {"src":"/_next/static/media/spotify-logo.52a05509.svg","height":225,"width":236,"blurWidth":0,"blurHeight":0};